export default __webpack_public_path__ + "static/media/my-img-1.bf8e11ec.png";